module.exports = __webpack_public_path__ + "static/Gilroy-SemiBold-cebe7ce423f3b39d5d4aec7f8ac9af0c.woff";